import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Shell from '../../../common/components/Shell/Shell';
import DTOTraining from './DTOTraining';
import TrainingPresenter from './TrainingPresenter';

function TrainingController() {
  const { t, i18n } = useTranslation();
  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: 'auto',
          marginLeft: i18n.language == 'en' ? '7.25em' : '',
        }}
      >
        <DTOTraining />
        <TrainingPresenter trans={t} i18n={i18n} />
      </Grid>
    </Shell>
  );
}
export default TrainingController;
